import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AuthState } from "./authSliceTypes";
import type { User } from "@auth/types/auth";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        user: undefined
    } as AuthState,
    reducers: {
        setAuthenticated: (state, action: PayloadAction<User>) => ({
            ...state,
            user: action.payload,
            isAuthenticated: true,
        }),
        removeAuthenticated: (state) => ({
            ...state,
            user: undefined,
            isAuthenticated: false,
        }),
    },
});

export const { setAuthenticated, removeAuthenticated } = authSlice.actions;